import { slugify } from '@src/utils/slugify';
import {
  extractFilterValues,
  extractModuleFromALevelRow,
  extractChapterFromALevelRow,
  createNumericalSort,
  sortDynamicField,
} from '@src/components/DynamicTable/helpers';

export const enhanceTopicALevelFurtherColumns = (columns, { rows = [] } = {}) => {
  // columns here are already enhanced by defaultColumnEnhancer with basic sorting
  // We only need to add more complex sorting for specific cases
  const enhancedColumns = columns
    .map((col) => {
      const id = slugify(col.id); // Use existing id, just slugify for comparison

      switch (id) {
        case 'module':
          return {
            ...col,
            sortingFn: sortDynamicField(
              'module',
              (a, b) => {
                const sortOrder = [
                  'as-core',
                  'a-level-core',
                  'fm1',
                  'fm2',
                  'fs1',
                  'fs2',
                  'fp1',
                  'fp2',
                ];
                const indexA =
                  sortOrder.indexOf(a) !== -1 ? sortOrder.indexOf(a) : sortOrder.length;
                const indexB =
                  sortOrder.indexOf(b) !== -1 ? sortOrder.indexOf(b) : sortOrder.length;
                return indexA - indexB;
              },
              'aLevelFurtherColumnTwo',
            ),
          };

        case 'textbook-chapter':
          return {
            ...col,
            sortingFn: createNumericalSort('aLevelFurtherChapter'),
          };

        case 'difficulty':
          return {
            ...col,
            sortingFn: sortDynamicField(
              'difficulty',
              (a, b) => {
                const difficultyOrder = { easy: 1, medium: 2, hard: 3, 'very-hard': 4 };
                const valueA = difficultyOrder[a?.toLowerCase()] ?? 0;
                const valueB = difficultyOrder[b?.toLowerCase()] ?? 0;
                return valueA - valueB;
              },
              'aLevelFurtherColumnFour',
            ),
          };

        default:
          // Keep the default enhanced column (sortable already determined by presence of sortingFn)
          return { ...col, sortingFn: undefined };
      }
    })
    .filter(Boolean);

  // Extract filter values if rows are provided
  if (rows.length > 0) {
    const moduleValues = extractFilterValues(rows, extractModuleFromALevelRow);
    const chapterValues = extractFilterValues(rows, extractChapterFromALevelRow);

    // Add filter metadata to the columns object
    if (moduleValues.length > 0 || chapterValues.length > 0) {
      enhancedColumns.filterControls = {
        moduleValues: moduleValues.sort(),
        chapterValues: chapterValues.sort((a, b) => a - b),
      };
    }
  }

  return enhancedColumns;
};

export default enhanceTopicALevelFurtherColumns;
